import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReportLogOfEvents } from '@report/models/report-of-event-log';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-report-events-log-with-activity-groups',
  templateUrl: './report-events-log-with-activity-groups.component.html',
  styleUrls: ['./report-events-log-with-activity-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportEventsLogWithActivityGroupsComponent {
  @Input({ required: true }) reportLogOfEvent: ReportLogOfEvents;
  @Input({ required: true }) eventLogPrefix: string;
  StaticMessage = StaticMessage;
}
